import $ from 'jquery';
import 'imagesloaded';

export default class DynamicSlideshow {
  constructor(section) {
    this.el = section.el;

    this.slides = $('.slide', this.el);
    this.slideshow = $('.slideshow', this.el);
    this.jumpLinksWrap = $('.jump-to-slide', this.el);
    this.fadeSpeed = 400;
    this.autoPlay = parseInt($('.slideshow', this.el).attr('data-autoplay'), 10);

    // Setup the slides and jump pagination
    this.slides.first().addClass('first');
    this.slides.last().addClass('last');

    // Reset pagination count
    this.jumpLinksWrap.html('');

    for (let i = 0; i < this.slides.length; i++) {
      const $slide = $(this.slides[i]);

      if (this.slides.length > 0) {
        this.jumpLinksWrap.append($('<li>'));
      }

      if (i === 0) {
        $slide.imagesLoaded(() => $slide.fadeTo(
          '200',
          1,
          () => {
            const height = $slide.height();
            $slide.css('z-index', 2000).addClass('active');
            $slide.parent().css('height', height);
          },
        ));
      }
    }

    this.jumpLinks = this.jumpLinksWrap.find('li');
    this.jumpLinksWrap.find('li:first').addClass('active');

    // Add context to section following slideshow
    if (this.slideshow.attr('data-full-width') === 'true') {
      this.slideshow.parents('.shopify-section').next('.shopify-section').addClass('slideshow-sibling-section');
    }

    // Remove pagination when only one slide is present
    if (this.slides.length === 1) {
      $('.next, .prev, .jump-to-slide', this.el).remove();
    }

    // Setup autplay / auto-rotation of slideshow
    if (this.autoPlay > 1) {
      this.autoPlaySlides();
    }

    // Set height of active slide on window resize
    $(window).resize(() => $('.slideshow', this.el).css({
      height: (this.slides.filter('.active').height()),
    }));

    $('.next', this.el).on('click', this.nextSlide.bind(this));
    $('.prev', this.el).on('click', this.previousSlide.bind(this));
    $('.jump-to-slide li', this.el).on('click', this.jumpToSlide.bind(this));
  }

  selectedHeight(el) {
    clearTimeout(this.timeout);

    $(el).imagesLoaded(() => {
      this.timeout = setTimeout(
        () => {
          $('.slide', this.el).removeClass('active');
          $(el).addClass('active');
          $('.slideshow', this.el).css({ height: $(el).height() });
        },
        1000,
      );
    });
  }

  autoPlaySlides() {
    if ($('.slideshow', this.el).hasClass('autoplay-enabled')) { return; }

    if (this.slides.length > 1) {
      $('.slideshow', this.el).addClass('autoplay-enabled');

      this.interval = setInterval(
        () => {
          if (!$('.slideshow', this.el).hasClass('paused')) {
            this.nextSlide();
          }
        },
        this.autoPlay,
      );
    }
  }

  slideStatus() {
    $('.slideshow', this.el).toggleClass('paused');
  }

  lockSlide(event) {
    this.slidesLocked = true;
    $('.slideshow', this.el).addClass('paused');
    this.jumpToSlide(event);
    this.selectedHeight(event.target);
  }

  unlockSlide() {
    this.slidesLocked = false;
    $('.slideshow', this.el).removeClass('paused');
  }

  nextSlide() {
    const isLast = $('.slide.active', this.el).hasClass('last');
    const upcomingSlide = isLast ? this.slides.first() : $('.slide.active', this.el).next();
    this.switchToSlide(upcomingSlide);
  }

  previousSlide() {
    const isFirst = $('.slide.active', this.el).hasClass('first');
    const upcomingSlide = isFirst ? this.slides.last() : $('.slide.active', this.el).prev();
    this.switchToSlide(upcomingSlide);
  }

  jumpToSlide(event) {
    const jumpPosition = $(event.target).index();
    const upcomingSlide = this.slides.eq(jumpPosition);
    this.switchToSlide(upcomingSlide);
  }

  switchToSlide(upcomingSlide) {
    const currentSlide = $('.slide.active', this.el);
    const upcomingSlidePosition = upcomingSlide.index();

    // Update jumpLinks
    for (let i = 0; i < this.jumpLinksWrap.length; i++) {
      const jumpLinksWrap = $(this.jumpLinksWrap[i]);
      const jumpLinks = jumpLinksWrap.find('li');
      const upcomingJumpLink = jumpLinks.eq(upcomingSlidePosition);
      const currentJumpLink = jumpLinks.filter('.active');

      currentJumpLink.removeClass('active');
      upcomingJumpLink.addClass('active');
    }

    // Adjust slideshow height
    $('.slideshow', this.el).css({ height: upcomingSlide.height() });

    // Fire away!
    currentSlide.fadeTo(this.fadeSpeed, 0, () => currentSlide.removeClass('active'));
    upcomingSlide.fadeTo(this.fadeSpeed, 1, () => upcomingSlide.addClass('active'));
  }

  onSectionBlockSelect(data) {
    const event = {
      target: data.el,
    };

    this.lockSlide(event);
  }

  onSectionBlockDeselect() {
    this.unlockSlide();
  }

  onSectionUnload() {
    clearTimeout(this.timeout);
    clearInterval(this.interval);
    $('.next', this.el).off('click');
    $('.prev', this.el).off('click');
    $('.jump-to-slide li', this.el).off('click');
  }
}
